import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { Flame, Lock } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/");
    else setErr(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      {/* Visual */}
      <div
        className="hidden lg:flex relative items-end p-12 text-white"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,10,10,0.55), rgba(10,10,10,0.85)), url('https://images.pexels.com/photos/16271901/pexels-photo-16271901.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200')",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      >
        <div className="max-w-md">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-9 h-9 bg-white rounded-sm flex items-center justify-center">
              <Flame size={20} className="text-black" strokeWidth={2.5} />
            </div>
            <div className="font-heading font-black text-xl tracking-tight">LPG MANAGER</div>
          </div>
          <h2 className="font-heading font-black text-5xl tracking-tight leading-[1.05] mb-4">
            Every cylinder.<br/>Every challan.<br/>One place.
          </h2>
          <p className="text-gray-300 text-base leading-relaxed">
            Built for small LPG traders. Fast entry, live stock, pending payments,
            cylinder rotation and instant PDF ledgers — all in one simple dashboard.
          </p>
        </div>
      </div>

      {/* Form */}
      <div className="flex flex-col justify-center px-6 sm:px-12 py-12 bg-white">
        <div className="w-full max-w-md mx-auto">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="w-9 h-9 bg-black rounded-sm flex items-center justify-center">
              <Flame size={20} className="text-white" strokeWidth={2.5} />
            </div>
            <div className="font-heading font-black text-lg tracking-tight">LPG MANAGER</div>
          </div>

          <div className="small-label text-gray-500 mb-2">Sign in</div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mb-2">
            Welcome back.
          </h1>
          <p className="text-gray-600 mb-8">Use your admin credentials to continue.</p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="small-label block mb-2">Email</label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-lg" placeholder="you@example.com"
                data-testid="login-email-input" autoComplete="email" required
              />
            </div>
            <div>
              <label className="small-label block mb-2">Password</label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-lg" placeholder="••••••••"
                data-testid="login-password-input" autoComplete="current-password" required
              />
            </div>
            {err && (
              <div className="text-sm text-[#B91C1C] bg-[#FEE2E2] border border-[#FECACA] rounded px-3 py-2" data-testid="login-error">
                {err}
              </div>
            )}
            <button type="submit" disabled={busy} className="btn-primary w-full h-12 flex items-center justify-center gap-2" data-testid="login-submit-button">
              <Lock size={16} /> {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
